const brandH5Header = { h5Header: true, h5HeaderTone: "brand" };

const routes = [
    { name: "user_info", path: "/index", component: () => import("@/views/account/user.vue") },
    {
        name: "user_setting",
        path: "/setting",
        component: () => import("@/views/account/setting.vue"),
        meta: { ...brandH5Header, h5TitleKey: "setting.title" },
    },
    {
        name: "user_setting_company",
        path: "/setting/company",
        component: () => import("@/views/account/setting_company.vue"),
        meta: { ...brandH5Header, h5TitleKey: "company.title", h5BackFallback: { name: "user_setting" } },
    },
    {
        name: "user_setting_about",
        path: "/setting/about",
        component: () => import("@/views/account/setting_about.vue"),
        meta: { ...brandH5Header, h5TitleKey: "about.title", h5BackFallback: { name: "user_setting" } },
    },
    {
        name: "user_setting_agreement",
        path: "/setting/agreement",
        component: () => import("@/views/account/setting_legal.vue"),
        meta: {
            legalType: "agreement",
            ...brandH5Header,
            h5TitleKey: "about.userAgreement",
            h5BackFallback: { name: "user_setting_about" },
        },
    },
    {
        name: "user_setting_privacy",
        path: "/setting/privacy",
        component: () => import("@/views/account/setting_legal.vue"),
        meta: {
            legalType: "privacy",
            ...brandH5Header,
            h5TitleKey: "about.privacyPolicy",
            h5BackFallback: { name: "user_setting_about" },
        },
    },
    {
        name: "user_setting_open_source",
        path: "/setting/open-source",
        component: () => import("@/views/account/setting_legal.vue"),
        meta: {
            legalType: "openSource",
            ...brandH5Header,
            h5TitleKey: "about.openSourceNotice",
            h5BackFallback: { name: "user_setting_about" },
        },
    },
    {
        name: "user_messages",
        path: "/i/message",
        component: () => import("@/views/account/message.vue"),
        meta: { ...brandH5Header, h5TitleKey: "message.title" },
    },
    {
        name: "user_email",
        path: "/i/email",
        component: () => import("@/views/account/email.vue"),
        meta: { ...brandH5Header, h5TitleKey: "email.bindTitle", h5BackFallback: { name: "user_setting" } },
    },
    {
        name: "user_wechat",
        path: "/i/wxmp",
        component: () => import("@/views/account/wechat.vue"),
        meta: { ...brandH5Header, h5TitleKey: "wechat.title", h5BackFallback: { name: "user_setting" } },
    },
    {
        name: "email_verify",
        path: "/account/email/verify",
        component: () => import("@/views/account/email_verify.vue"),
    },
];

export default routes;
